<template>
   <div class="card m-3">
      <div class="card-header">
        <h2 align="left">Crosstab Analysis</h2>
        </div>
      <div class="card-body">
        <vue-pivottable-ui
            v-model="config"
            :data="data"
            :localeStrings="localeStrings[locale]"
            :rendererName="rendererName"
            :renderers=renderers
            :aggregatorName="aggregatorName"
            :aggregators="aggregators"
            :tableColorScaleGenerator="colorScaleGenerator"
            :attributes="attributes"
            :rows="rows"
            :cols="cols"
            :vals="vals"
            :disabledFromDragDrop="disabledFromDragDrop"
            :sortonlyFromDragDrop="sortonlyFromDragDrop"
            :hiddenFromDragDrop="hiddenFromDragDrop"
            :hiddenFromAggregators="hiddenFromAggregators"
            :sorters="sorters"
            rowOrder="value_a_to_z"
        >
          <colgroup slot="colGroup">
            <col :width="300">
            <col>
          </colgroup>
          <div v-if="loading" slot="output">
            loading...
          </div>
          <template v-if="!loading" slot="output" slot-scope="{ pivotData }">
            {{ pivotData }}
          </template>
          <template slot="pvtAttr" slot-scope="{ name }">
            {{ name }}
          </template>
        </vue-pivottable-ui>
        </div>
     </div>
</template>

<script>
import {PivotUtilities, Renderer, VuePivottableUi} from 'vue-pivottable'
import 'vue-pivottable/dist/vue-pivottable.css'
import {scaleLinear} from 'd3-scale'
import axios from "axios";

export default {
  components: {
    VuePivottableUi
    // VuePivottable
  },
  name: 'app',
  data () {
    return {
      // fix issue #27
      /*valueFilter: {
        Meal: {
          Dinner: true
        }
      },*/
      config: {},
      filteredData: [],
      data:[],
      attributes: ['platform','tractor make','tractor model','hp','location','wheel drive type','configuration','test type','season','soil type','gear','rpm drop straight','rpm drop turn','depth of cut','application type','application','engine speed rpm','travel speed kmph','wheel slip %','fc lit/hr','fc lit/acr','area covered acr/hr'],
      rows: ['platform'],
      cols: ['location', 'application'],
      vals: ['fc lit/hr'],
      disabledFromDragDrop: [], // ['Payer Gender'],
      hiddenFromDragDrop: [ 'wheel slip %', 'fc lit/hr', 'fc lit/acr', 'area covered acr/hr'],
      sortonlyFromDragDrop: [], // ['Party Size'],
      hiddenFromAggregators: ['platform','tractor make','tractor model','hp','location','wheel drive type','configuration','test type','season','soil type','gear','rpm drop straight','rpm drop turn','depth of cut','application type','application','engine speed rpm','travel speed kmph'],
      loading: false,
      aggregatorName: 'Average',
      rendererName: 'Table',
      localeStrings: {
        en: {
          renderError: 'An error occurred rendering the PivotTable results.',
          computeError: 'An error occurred computing the PivotTable results.',
          uiRenderError: 'An error occurred rendering the PivotTable UI.',
          selectAll: 'Select All',
          selectNone: 'Select None',
          tooMany: 'too many values to show',
          filterResults: 'Filter values',
          totals: 'Totals',
          only: 'only'
        }
      },
      locale: 'en'
    }
  },
  created () {
    setTimeout(() =>  {
      // this.data = tips
      var url = '/api/fetchDataWithParam/SQL700/Any'
      axios.post(url, {}).then( res => {
      var response = res.data
        /* axios({ url: '/json/bank_data.json', baseURL: '', method: 'GET' }).then(res => {*/
        this.data= response.rowsData
        //console.log("pivot test data:::",this.data)
      })
    }, 1000)
  },
  computed: {
    sorters() {
      return {
        'Day of Week': PivotUtilities.sortAs(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'])
      }
    },
    unusedAttrs() {
      return this.config.unusedAttrs
    },

    renderers() {
      const TableRenderer = Renderer.TableRenderer
      // const PlotlyRenderer = Renderer.PlotlyRenderer
      return (() => ({
            'Table': TableRenderer.Table,
            'Heatmap': TableRenderer['Table Heatmap'],
            //'Table Col Heatmap': TableRenderer['Table Col Heatmap'],
            //'Table Row Heatmap': TableRenderer['Table Row Heatmap'],
            //'Export Table TSV': TableRenderer['Export Table TSV']
          })
      )()
    },
    aggregators() {
      const usFmt = PivotUtilities.numberFormat()
      const usFmtInt = PivotUtilities.numberFormat({ digitsAfterDecimal: 0 })
      // const usFmtPct = PivotUtilities.numberFormat({
      //   digitsAfterDecimal: 1,
      //   scaler: 100,
      //   suffix: '%'
      // })
      return ((tpl) => ({
            'Count': tpl.count(usFmtInt),
            //'Count Unique Values': tpl.countUnique(usFmtInt),
            'List Unique Values': tpl.listUnique(', '),
            Sum: tpl.sum(usFmt),
            // 'Integer Sum': tpl.sum(usFmtInt),
            'Average': tpl.average(usFmt) //,
            // 'Median': tpl.median(usFmt),
            // 'Sample Variance': tpl.var(1, usFmt),
            // 'Sample Standard Deviation': tpl.stdev(1, usFmt),
            // 'Minimum': tpl.min(usFmt),
            // 'Maximum': tpl.max(usFmt),
            // 'First': tpl.first(usFmt),
            // 'Last': tpl.last(usFmt),
            // 'Sum over Sum': tpl.sumOverSum(usFmt),
            // 'Sum as Fraction of Total': tpl.fractionOf(tpl.sum(), 'total', usFmtPct),
            // 'Sum as Fraction of Rows': tpl.fractionOf(tpl.sum(), 'row', usFmtPct),
            // 'Sum as Fraction of Columns': tpl.fractionOf(tpl.sum(), 'col', usFmtPct),
            // 'Count as Fraction of Total': tpl.fractionOf(tpl.count(), 'total', usFmtPct),
            // 'Count as Fraction of Rows': tpl.fractionOf(tpl.count(), 'row', usFmtPct),
            // 'Count as Fraction of Columns': tpl.fractionOf(tpl.count(), 'col', usFmtPct)
          })
      )(PivotUtilities.aggregatorTemplates)
    }
  },
  methods: {
    colorScaleGenerator (values) {
      const scale = scaleLinear()
          .domain([0, Math.max.apply(null, values)])
          .range(['#fff', '#77f'])
      return x => {
        return { 'background-color': scale(x) }
      }
    }
  },
  watch: {
    config: {
      handler (value) {
        const PivotData = PivotUtilities.PivotData
        // this.data = tips
        this.filteredData = new PivotData(value).getFilteredData()
      },
      deep: true,
      immediate: false
    }
  }
}
</script>

<style>
.main {
  max-width: 980px;
  margin: 8vh auto 20px;
}
.title {
  text-align: center;
  margin-bottom: 20px;
}
h1 {
  margin-bottom: 0px;
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
}
pre {
  text-align: left;
  background-color: #f8f8f8;
  padding: 1.2em 1.4em;
  line-height: 1.5em;
  margin: 60px 0 0;
  overflow: auto;
}
code {
  padding: 0;
  margin: 0;
}
footer {
  text-align: center;
  margin-top: 40px;
  line-height: 2;
}
</style>
